import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { CssBaseline } from '@material-ui/core';
import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

import { ErrorBoundary, LocaleProvider } from './components';
import { Routes } from './containers';
import { GlobalStyle, theme } from './styles';
import { setupInterceptors } from './utils';
import configureStore from './configureStore';

const { store } = configureStore();

setupInterceptors(store);

const App = ({ translation }) => (
  <StylesProvider injectFirst>
    <Provider store={store}>
      <LocaleProvider translation={translation}>
        <ThemeProvider theme={theme}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
              <GlobalStyle />
              <Routes />
            </ErrorBoundary>
          </MuiThemeProvider>
        </ThemeProvider>
      </LocaleProvider>
    </Provider>
  </StylesProvider>
);

App.propTypes = {
  translation: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default App;
